import React, { Suspense, lazy, useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

const Home = lazy(() => import('./components/pages/Home'));
const AboutUs = lazy(() => import('./components/pages/AboutUs'));
const Treatments = lazy(() => import('./components/pages/Treatments'));
const Register = lazy(() => import('./components/pages/Register'));
const Analytics = lazy(() =>
  import('@vercel/analytics/react').then((module) => ({ default: module.Analytics }))
);
const SpeedInsights = lazy(() =>
  import('@vercel/speed-insights/react').then((module) => ({ default: module.SpeedInsights }))
);

function App() {
  const [showInsights, setShowInsights] = useState(false);

  useEffect(() => {
    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(() => {
        setShowInsights(true);
      }, { timeout: 2000 });

      return () => {
        window.cancelIdleCallback(idleId);
      };
    }

    const timeoutId = window.setTimeout(() => {
      setShowInsights(true);
    }, 1200);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <Router>
        <Navbar />
        <Suspense fallback={null}>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/aboutus' element={<AboutUs />} />
            <Route path='/treatments' element={<Treatments />} />
            <Route path='/register' element={<Register />} />
          </Routes>
        </Suspense>
      </Router>
      {showInsights && (
        <Suspense fallback={null}>
          <Analytics />
          <SpeedInsights />
        </Suspense>
      )}
    </>
  );
}

export default App;
